const prvaDiagnozaIdd2 = {
    q11: { 
        name: 'q11',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Ali menite, da obvezno zdravstveno zavarovanje krije vse vaše potrebe iz vidika zdravstvenih storitev?',
        },
    },
    q12: { 
        name: 'q12',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Zahtevam predstavitev dodatnih možnosti',
        },
    },
    q21: { 
        name: 'q21',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Ali menite, da potrebujete oziroma bi lahko v prihodnosti potrebovali dostop do dodatnih zdravstvenih storitev na področju preventive, diagnostike, zdravljenja, rehabilitacije v Sloveniji in drugih državah?',
        },
    },
    q22: { 
        name: 'q22',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Zahtevam predstavitev možnosti glede dodatnih zdravstvenih kritij',
        },
    },
    q31: { 
        name: 'q31',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Ali menite, da je potrebno diagnozo in načrt zdravljenja preverjati?',
        },
    },
    q32: { 
        name: 'q32',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Zahtevam predstavitev dodatnih možnosti glede drugega zdravniškega mnenja najboljših zdravnikov specialistov v svetovnem merilu',
        },
    },
    q41: { 
        name: 'q41',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Ali želite poiskati najboljšo možnost za vaše zdravljenje?',
        },
    },
    q42: { 
        name: 'q42',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Zahtevam predstavitev dodatnih možnosti glede asistence pri iskanju najboljših možnosti za zdravljenje',
        },
    },
    q51: { 
        name: 'q51',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Ali vas zanimajo možnosti zdravljenja v tujini?',
        },
    },
    q52: { 
        name: 'q52',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Zahtevam predstavitev možnosti glede zdravstvenih kritij v drugih državah',
        },
    },
    q61: { 
        name: 'q61',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Ali bi hujša bolezen vas ali vaših bližnjih finančno vplivala na vas in vašo družino?',
        },
    },
    q62: { 
        name: 'q62',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Zahtevam predstavitev možnosti glede finančne zaščite v primeru hujših bolezenskih stanj in njihovih posledic',
        },
    },
    q71q72q73: {
        name: 'q71q72q73',
        type: 'quasi',
        formType: 'radio-multiple',
        value: undefined,
        required: true,
        text: {
            sl: 'Ali vam je pomembno, da bi vaše zavarovanje sledilo smernicam trajnostnosti v smislu varovanja okolja[1] (zniževanje ogljičnega odtisa, učinkovita raba vodnih virov in energije, zniževanje uporabe ali odvisnosti od fosilnih goriv ...), socialnih pravic[2] (rasna, spolna in verska raznolikost, skrb za zdravje in varnost ...) in korektno upravljanje poslovanja[3] (transparentnost poslovanja, etika in vrednote, spolna raznolikost zaposlenih …)?',
        },
        options: [
            { 
                name: 'q71',
                type: 'tns:DaNe',
                formType: 'radio-option',
                text: {
                    sl: 'Zelo mi je pomembno',
                },
                value: 'q71',
            },
            { 
                name: 'q72',
                type: 'tns:DaNe',
                formType: 'radio-option',
                text: {
                    sl: 'Zmerno mi je pomembno',
                },
                value: 'q72',
            },
            { 
                name: 'q73',
                type: 'tns:DaNe',
                formType: 'radio-option',
                text: {
                    sl: 'Ni mi pomembno',
                },
                value: 'q73',
            },  
        ],
    },
    q1potrjujemq2nezelim: {
        name: 'q1potrjujemq2nezelim',
        type: 'quasi',
        formType: 'prva-diagnoza-idd2-q1potrjujemq2nezelim',
        value: undefined,
        required: true,
        text: {
            sl: '',
        },
        options: [
            { 
                name: 'q1potrjujem',
                type: 'xs:boolean',
                formType: 'radio-option',
                text: {
                    sl: 'Potrjujem, da je zavarovalni zastopnik na podlagi informacij opredelil moje potrebe in zahteve ter mi preko objektivnih informacij o zavarovalnem produktu na razumljiv način omogočil informirano odločitev, kot izhaja iz podpisane ponudbe/zavarovalne police.',
                },
                value: 'q1potrjujem',
            },
            { 
                name: 'q2nezelim',
                type: 'xs:boolean',
                formType: 'radio-option',
                text: {
                    sl: 'Ne želim podati informacij za določitev mojih potreb in zahtev ter potrjujem, da je zavarovalni zastopnik na podlagi moje izrecne zahteve ter predstavitve objektivnih informacij o zavarovalnem produktu na razumljiv način omogočil informirano odločitev, kot izhaja iz podpisane ponudbe/zavarovalne police.',
                },
                value: 'q2nezelim',
            },
        ],
    },
    podpisZavarovalec: {
        name: 'podpisZavarovalec',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis zavarovalca',
        },
    },
    podpisSvetovalec: {
        name: 'podpisSvetovalec',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis svetovalca',
        },
    },
    krajPodpisa: {
        name: 'krajPodpisa',
        type: 'xs:string',
        formType: 'text-input',
        required: true,
        value: undefined,
        text: {
            sl: 'Kraj podpisa brez datuma',
        },                
    },
    datumPodpisa: {
        name: 'datumPodpisa',
        type: 'xs:dateTime',
        formType: 'auto-date-time-now',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis svetovalca',
        },
    }
};

module.exports = { prvaDiagnozaIdd2 };